import { isExternalContent } from "~/Configurators/Linear/hooks/useExternalContent";
import { resolveUrlLanguage } from "~/Configurators/Linear/components/LanguageAwareExternalContent";
import { requestExternalContent } from "~/redux/externalContent/actions";
import { type RootState } from "~/redux/store";
import { type AnyAction } from "~/redux/types";
import { type ThunkAction } from "redux-thunk";
import { removeDivTags, removePTags, removeSpanTags, removeTags } from "~/utils/domUtils";
import type { SummaryDataProvider } from "~/Configurators/Shaft/SummaryDataProvider";

type ThunkResult<R> = ThunkAction<R, RootState, undefined, AnyAction>;
export function grabExternalTranslation(key: string): ThunkResult<Promise<string>> {
  return async (dispatch, getState) => {
    if (isExternalContent(key)) {
      key = resolveUrlLanguage(key, "en")!;
      let text = await dispatch(requestExternalContent(key));
      text = text!.trim();
      text = removeInternalNewlinesAndMultispaces(text);
      text = removePTags(text)!;
      text = removeDivTags(text)!;
      text = removeSpanTags(text)!;
      return text;
    }

    return key;
  };
}

const removeInternalNewlinesAndMultispaces = (text: string) => {
  return text.replace(/[\r\n]/gim, " ").replace(/  +/gim, " ");
};

export function grabXmlTranslation(summaryDataProvider: SummaryDataProvider, key: string) {
  let text = summaryDataProvider.t(key);
  text = text!.trim();
  text = removeInternalNewlinesAndMultispaces(text);
  text = removePTags(text)!;
  text = removeDivTags(text)!;
  text = removeSpanTags(text)!;
  text = removeTags(text, "h6")!;
  return text;
}
